import React, {useEffect, useState} from 'react';
import { Helmet } from 'react-helmet-async';
import {AppStateInstance} from "./AppState/AppStateContext";
import {waitUntilDefined} from "./util/UtilityFunctions";

// import { useGlobalState } from './AppState';

const HtmlHead = () => {

  const [scriptUrl, setScriptUrl] = useState('')

  const appState = React.useContext(AppStateInstance)

  useEffect(()=> {
    waitUntilDefined(()=> {return appState.globalState.aaScriptUrl}).then(()=>setScriptUrl(appState.globalState.aaScriptUrl))
  },[appState.globalState])

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" href="/favicon.ico" />
      <link
        as="font"
        crossOrigin="anonymous"
        href="../src/resources/fonts/NexusSansWebPro-Regular.woff2"
        type="font/woff2"
      />
      <meta name="theme-color" content="#000000" />
      <title>Reference Analyzer</title>
      <meta name="description" content="Analyze manuscript references" />
      <link rel="manifest" href="/manifest.json" />
      <script src={scriptUrl} async></script>
    </Helmet>
  )
}

export default HtmlHead
